import { BASE_URL } from "api";
import { useEffect, useState } from "react";
import RedirectionFailure from "./redirection-failure";
import RedirectionSuccess from "./redirection-success";


const Confirmation = () => {
    const [showSuccess, setShowSuccess] = useState<boolean | null>(null);
    const [errorDetail, setErrorDetail] = useState<string | null>(null);
    useEffect( () => {
        (async () => {
        try {
            const callbackParams = (window.location.hash || window.location.search).substring(1);
            const params = new URLSearchParams(callbackParams);
            const bankError = params.get('error');
            const bankErrorDescription = params.get('error_description');

            if (bankError || bankErrorDescription) {
                setShowSuccess(false);
                setErrorDetail(
                    [bankError, bankErrorDescription].filter(Boolean).join(' — '),
                );
                return;
            }

            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: null
            };
            
            const result = await fetch( BASE_URL + "/orchestrator/completeJourney?"+callbackParams, requestOptions);
            const body = await result.text();
            let payload: any;
            try {
                payload = JSON.parse(body);
            } catch {
                payload = undefined;
            }

            if (!result.ok || payload?.success === false || payload?.codes >= 400) {
                setShowSuccess(false);
                setErrorDetail(`completeJourney ${result.status}: ${body.slice(0, 500)}`);
                return;
            }
            setShowSuccess(true);
        } catch(ex: unknown){
            console.error('Error Saving Consent', ex);
            setShowSuccess(false);
            setErrorDetail(ex instanceof Error ? ex.message : String(ex));
        }
        })();
    },[])
 
    return (<>
        {showSuccess === true && <RedirectionSuccess></RedirectionSuccess>}
        {showSuccess === false && <RedirectionFailure errorDetail={errorDetail} />}
       </>
    );
 };
 
 export default Confirmation;